module.exports = __webpack_public_path__ + "img/img_market.b4581a9e.png";